
@if (afterLogin == false) {
  <div class="footer-section">
    <div class="container"  >
      <div class="top-offset">
      </div>
      <div class="row" >
        <div class="col-md-3 mt-4">
          <a class="navbar-brand" href="#">
            <img src="../../assets/logo.png" alt="" width="54" height="54">
          </a>
          <p class="slogan-caption my-3">
            Project and Knowledge Management
          </p>
          <div class="getstarted-button mt-3" routerLink="/login">
            <div class="getstarted-caption">
              Get started now
            </div>
          </div>
        </div>
        <div class="col-md-3 mt-5">
          <h4 class="small-header">Use Cases</h4>
          <p class="my-4">
            <a (click)="navigateTo('about')" class="link-caption">Project management</a>
          </p>
          <p class="my-4">
            <a (click)="navigateTo('about')"class="link-caption">Community management</a>
          </p>
          <p class="my-4">
            <a (click)="navigateTo('about')" class="link-caption">Knowledge management</a>
          </p>
        </div>
        <div class="col-md-3 mt-5">
          <h4 class="small-header">Company</h4>
          <p class="my-4">
            <a (click)="navigateTo('about')" class="link-caption">About</a>
          </p>
          <!--p class="my-4">
          <a  (click)="navigateTo('careers')"class="link-caption">Careers</a>
        </p-->
        <!--p class="my-4">
        <a  (click)="navigateTo('creator')" class="link-caption">The Creator</a>
      </p-->
    </div>
    <div class="col-md-3 mt-5">
      <h4 class="small-header">Legal</h4>
      <p class="my-4">
        <a (click)="navigateTo('pricing')" class="link-caption">Pricing</a>
      </p>
      <p class="my-4">
        <a (click)="navigateTo('terms')" class="link-caption">Terms of service</a>
      </p>
      <p class="my-4">
        <a (click)="navigateTo('privacy')"class="link-caption">Privacy policy</a>
      </p>
      <!--p class="my-4">
      <a (click)="navigateTo('refund')" class="link-caption">Refund policy</a>
    </p-->
  </div>
</div>
<div class="horizontal-line my-1"></div>
<div class="copy-caption my-4">
  Copyright © 2024 Octigo sp. z o.o. All rights reserved.
</div>
</div>
</div>
}
@if (afterLogin == true) {
  <div class=" footer-section-logged w-100">
    <div class="footer-caption w-100 p-1">
      Octigo sp. z o.o. |  Wroolo, contact us at contact&#64;wroolo.com | Have invitation code? <a (click)="navigateTo('startscreen')"class="retro-font-color-light">type it here</a>
    </div>
  </div>
}
